import React, { useMemo } from "react";
import { motion } from "framer-motion";
import "../styles/brands.css";
import SectionHeader from "../components/common/SectionHeader/sectionHeader";


export const Brands = () => {
  const sectionViewport = {
    once: true,
    amount: 0.35,
    margin: "0px 0px -15% 0px",
  };

  const fadeIn = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1, ease: "easeOut" } },
  };

  const brands = useMemo(() => {
    const importAll = (r) => r.keys().map(r);
    return importAll(require.context("../brands", false, /\.(png|jpe?g|gif)$/));
  }, []);

  return (
    <motion.div
      id="brands"
      initial="hidden"
      whileInView="visible"
      viewport={sectionViewport}
      variants={fadeIn}
    >
      <SectionHeader
        title="Who are they?"
        subtitle="Over the years, I’ve supported these brands across content and marketing, with feedback below from the clients I delivered that work for."
      />

      <motion.div
        className="carousel-wrapper"
        variants={fadeIn}
        initial="hidden"
        whileInView="visible"
        viewport={sectionViewport}
      >
        <motion.div
          className="brand-carousel"
          animate={{ x: ["0%", "-50%"] }} // infinite scroll
          transition={{
            repeat: Infinity,
            repeatType: "loop",
            duration: 30,
            ease: "linear",
          }}
        >
          {[...brands, ...brands].map((brand, index) => (
            <div key={index} className="brand">
              <img
                src={brand}
                alt={brand.split("/").pop()?.replace(/\.[^.]+$/, "") || "Brand logo"}
                className="brand-image"
              />
            </div>
          ))}
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default Brands;
